import React, { useState } from "react";
import { Formik, Form } from "formik";
import InputField from "../../../shared/components/InputField";
import { validationSchema } from "./LoginValidation"
import UserService from "../../../services/AuthService/auth.service";
import { withRouter } from "react-router-dom";
import '../auth.scss';
import ButtonComponent from "../../../shared/components/ButtonComponent";
import * as appRoutes from "../../../routes/routeConstants/appRoutes";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";
import { LocalStorage } from "../../../shared/utils/LocalStorageHelpers";

interface User {
    email: string,
    password: string
}

const initialValue = {
    email: "",
    password: ""
}

const LoginForm = (props: any) => {

    const [buttonLoading, setButtonLoading] = useState<boolean>(false)

    const onSubmit = (user: User) => {
        setButtonLoading(true);

        let data: any = {};

        data['admin'] = {
            ...user,
            grant_type: 'password'
        }

        UserService.loginUser(data,
            (user: any) => {
                LocalStorage.setItem("USER", user)
                Notification({ message: "Login", description: "Logged in successfully", type: NotificationTypes.SUCCESS });
                if (user.roleName === 'admin')
                    return props.history.push("/courses/boards");
               else
                    return props.history.push("/dashboard");
            }, (error: Error) => {
                Notification({ message: "Login failed", description: "incorrect email or password", type: NotificationTypes.ERROR });
                console.log(error.message);
            }, () => {
                setButtonLoading(false)
            }).then();
    }

    return (
        <div className='auth__form'>
            <div className='auth__header'>Welcome Back</div>
            <Formik
                initialValues={initialValue}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <div className="auth__input">
                        <InputField type="email" name="email" placeholder="Email ID" />
                    </div>
                    <div className="auth__input">
                        <InputField type="password" name="password" placeholder="Password" />
                    </div>
                    <div className="auth__option"
                        onClick={() =>
                            props.history.push(appRoutes.FORGOT_PASSWORD)
                        }>
                        Forgot Password
                    </div>
                    <div className='auth__action'>
                        <ButtonComponent buttonContent='Login'
                            type='primary'
                            htmlType='submit'
                            loading={buttonLoading}
                        />
                    </div>
                </Form>
            </Formik>
        </div>
    )
}

export default withRouter(LoginForm);
